import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {withAlert} from 'react-alert';
import Select from 'react-select';
import {getRequest, putRequest} from "../routes/Routes";
import '../assets/css/Home.css';
import {getUser} from "../auth/Auth";
import Loading from "../components/Loading";

class ManageUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {users: [], user: null, loading: true};
    }

    componentDidMount() {
        getUser(this.props.history).then(data => {
            this.setState({user: data});
            this.loadUsers();
        });
    }

    render() {
        if (this.state.user) {
            return (
                this.state.loading ?
                    <Loading/>
                    : <div className="container category-list partner-list">
                        <h1 className="heading">Users</h1>
                        <hr/>
                        <table className="w-100 users">
                            <thead>
                            <tr>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email</th>
                                <th>Address</th>
                                <th>City</th>
                                <th>Phone</th>
                                <th>Role</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.getUserBody()}
                            </tbody>
                        </table>
                    </div>
            );
        } else {
            return null;
        }
    }

    getUserBody = () => {
        let tableBody = [];
        const roleOptions = [
            {id: 1, name: 'Basic'},
            {id: 2, name: 'Partner'},
            {id: 3, name: 'Admin'}
        ];
        this.state.users.forEach((user, index) => {
            tableBody.push(
                <tr key={index}>
                    <td>{user.first_name}</td>
                    <td>{user.last_name}</td>
                    <td>{user.email}</td>
                    <td>{user.address}</td>
                    <td>{user.city}</td>
                    <td>{user.phone}</td>
                    <td>
                        <Select className="basic-single btn w-100" placeholder="Role" name="role"
                                id="role" options={roleOptions}
                                defaultValue={roleOptions.filter((item) => item.id === user.role_id)}
                                onChange={(event) => this.handleRoleChange(index, user, event)}
                                getOptionValue={option => option['id']} getOptionLabel={option => option['name']}/>
                    </td>
                </tr>
            )
        });

        return tableBody;
    };

    handleRoleChange = (index, user, event) => {
        let values = {
            email: user.email,
            role_id: event.id,
            endpoint: '/api/users',
            token: this.state.user.api_token
        };
        putRequest(values).then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    let {users} = this.state;
                    users[index] = response.data.user;
                    this.setState({users: users});
                    this.props.alert.success("Successfully Updated User");
                }
            } else {
                this.props.alert.error(response.data.message);
            }
        });
    };

    loadUsers = () => {
        let {users} = this.state;
        getRequest('/api/users', this.state.user.api_token).then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    users = response.data.users;
                    this.setState({users: users, loading: false});
                }
            } else {
                this.props.alert.error(response.data.message);
            }
        });
    };
}

export default withAlert()(withRouter(ManageUsers));
